export const getUsagePercent = (used: number, total: number | null): number => {
  if (!total) {
    return 0;
  }

  return Math.round((used / total) * 1000) / 10;
};
